module.exports = __webpack_public_path__ + "img/african-american-male-experience.6e6d415f.jpg";